import React, { Fragment, useEffect, useState } from "react";
import {
  addSections,
  isSectionValidate,
  _sectionTypes,
} from "./CreateAssessment";
import { useMediaQuery } from "@mui/material";
import { jfScoreTestType } from "../../../../../utils/Constants.js";
import Button from "../../../../../components/sub-component/Button";
import CustomTooltip from "../../../../../components/common/CustomTooltip";
import { ReactComponent as DangerIcon } from "../../../../../assets/icons/basic/danger.svg";
import { ReactComponent as DragIcon } from "../../../../../assets/icons/assessment-creation/drag.svg";
import { ReactComponent as LockIcon } from "../../../../../assets/icons/assessment-creation/lock.svg";
import { ReactComponent as SuccessIcon } from "../../../../../assets/icons/candidate-assessment/SCheckCircle.svg";

export default function CreateAssessmentTestTypes(props) {
  const {
    errorsInSections,
    selectedSectionType,
    setSelectedSectionType,
    selectedSectionIndex,
    getCurrentAssessmentComponentData,
    setSelectedSectionIndex,
    getSelectedOnRightSideMenuIndex,
    onUpdateSections,
    setErrorsInSections,
    fromDragIndex,
    setFromDragIndex,
    isEditAssessment,
  } = props;

  const isOnTabletScreen = useMediaQuery("(max-width:1200px)");
  const isOnMobileScreen = useMediaQuery("(max-width: 767px)");
  const [assessmentSpecsDetails, setAssessmentSpecsDetails] = useState(
    props.assessmentSpecsDetails
  );

  useEffect(() => {
    setAssessmentSpecsDetails(props.assessmentSpecsDetails);
  }, [props.assessmentSpecsDetails]);

  return (
    <>
      {!isOnMobileScreen && !isOnTabletScreen ? (
        <div className="create-assessment-secttion-options-container">
          <span className="subtitle-2 dark-100">Test Types</span>
          {/* <span className='body-2 dark-50'>{`Drag & drop components to create personalized assessments`}</span> */}
          <div className="section-type-container">
            {_sectionTypes?.map((sectionType, index) => {
              const draggable =
                !isOnTabletScreen &&
                !assessmentSpecsDetails?.sections?.find(
                  (section) => section?.type === sectionType?.id
                );
              const btnStatus =
                assessmentSpecsDetails?.sections?.filter(
                  (section) => section?.type === sectionType?.id
                )?.length > 0
                  ? errorsInSections.filter((_section, _) => {
                      return _section.testType === sectionType.id;
                    }).length > 0
                    ? { success: false }
                    : { success: true }
                  : null;
              return (
                <CustomTooltip
                  key={index}
                  text={
                    jfScoreTestType.includes(sectionType?.id) &&
                    isEditAssessment
                      ? ""
                      : "Drag and drop to add"
                  }
                  position="bottom-end"
                  width="100%"
                  disabled={isOnTabletScreen ? true : false}
                  customPosition={{
                    bottom: "0px",
                    left: "20px",
                  }}
                >
                  <Fragment>
                    {
                      <Button
                        onClick={() => {
                          //   if (isOnTabletScreen) {
                          //       setSelectedSectionType(sectionType.id);
                          //       setOnTabAddSectionStepNo(2);
                          //   }
                        }}
                        disabled={
                          jfScoreTestType.includes(sectionType?.id) &&
                          isEditAssessment
                        }
                        draggable={draggable}
                        onDragEnd={async () => {
                          addSections(
                            assessmentSpecsDetails,
                            selectedSectionType,
                            selectedSectionIndex,
                            isSectionValidate,
                            setAssessmentSpecsDetails,
                            getCurrentAssessmentComponentData,
                            setSelectedSectionIndex,
                            getSelectedOnRightSideMenuIndex,
                            onUpdateSections,
                            errorsInSections,
                            setErrorsInSections
                          );
                          // handlePlay1();
                        }}
                        onDragStart={() => {
                          setSelectedSectionType(sectionType.id);
                          setFromDragIndex(-1);
                        }}
                        className={`draggable body-2 dark-50
                    ${
                      selectedSectionIndex !== -1 &&
                      assessmentSpecsDetails?.sections[selectedSectionIndex]
                        ?.type === sectionType?.id
                        ? " in-section-btn-focused "
                        : ""
                    }
                    `}
                        key={index}
                        btn="in-section-btn-V2"
                        preIcon={sectionType.icon}
                        postIcon={
                          jfScoreTestType.includes(sectionType?.id) &&
                          isEditAssessment ? (
                            <LockIcon />
                          ) : btnStatus ? (
                            btnStatus.success === false ? (
                              <DangerIcon />
                            ) : (
                              <SuccessIcon />
                            )
                          ) : (
                            <DragIcon />
                          )
                        }
                        title={sectionType.title}
                        style={{
                          width: "100%",
                          color: "#808191",
                          pointerEvents:
                            jfScoreTestType.includes(sectionType?.id) &&
                            isEditAssessment
                              ? "none"
                              : "auto",
                          cursor: `${draggable ? "grab" : "not-allowed"}`,
                        }}
                      />
                    }
                  </Fragment>
                </CustomTooltip>
              );
            })}
          </div>
        </div>
      ) : (
        <div className="create-assessment-secttion-options-container w-100">
          <div className="section-type-container w-100">
            {_sectionTypes?.map((sectionType, index) => {
              const btnStatus =
                assessmentSpecsDetails?.sections?.filter(
                  (section) => section?.type === sectionType?.id
                )?.length > 0
                  ? errorsInSections.filter((_section, _) => {
                      return _section.testType === sectionType.id;
                    }).length > 0
                    ? { success: false }
                    : { success: true }
                  : null;
              return (
                <Fragment key={index}>
                  {
                    <Button
                      onClick={() => {
                        setSelectedSectionType(sectionType.id);
                        addSections(
                          assessmentSpecsDetails,
                          selectedSectionType,
                          selectedSectionIndex,
                          isSectionValidate,
                          setAssessmentSpecsDetails,
                          getCurrentAssessmentComponentData,
                          setSelectedSectionIndex,
                          getSelectedOnRightSideMenuIndex,
                          onUpdateSections,
                          errorsInSections,
                          setErrorsInSections
                        );
                        props.onCloseTestType();
                      }}
                      className={`draggable in-section-btn
            									${
                                btnStatus
                                  ? btnStatus.success === false
                                    ? " in-section-btn-danger "
                                    : " in-section-btn-success "
                                  : ""
                              }
            									${
                                selectedSectionIndex !== -1 &&
                                assessmentSpecsDetails?.sections[
                                  selectedSectionIndex
                                ]?.type === sectionType?.id
                                  ? " in-section-btn-focused "
                                  : ""
                              }

            									`}
                      key={index}
                      btn="in-section-btn"
                      disabled={
                        jfScoreTestType.includes(sectionType?.id) &&
                        isEditAssessment
                      }
                      preIcon={
                        btnStatus ? (
                          btnStatus.success === false ? (
                            <DangerIcon
                              style={{ width: "24px", height: "24px" }}
                            />
                          ) : (
                            <SuccessIcon
                              style={{ width: "24px", height: "24px" }}
                            />
                          )
                        ) : (
                          sectionType.icon
                        )
                      }
                      postIcon={
                        jfScoreTestType.includes(sectionType?.id) &&
                        isEditAssessment && <LockIcon />
                      }
                      title={sectionType.title}
                      style={{
                        width: "100%",
                        background: "#F6F5F8",
                        marginTop: index === 0 ? "0px" : "16px",
                        pointerEvents:
                          jfScoreTestType.includes(sectionType?.id) &&
                          isEditAssessment
                            ? "none"
                            : "auto",
                        cursor: `${"pointer"}`,
                      }}
                    />
                  }
                </Fragment>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
